import React from 'react';
import { useSelector } from 'react-redux';
import styles from './styles.module.css';

function Floor1TitleList({ floorLevel, isSvg = false }) {
  const targetProperty = floorLevel + 'F';
  const titleState = useSelector((state) => state.titleCoors);
  const title = titleState[targetProperty] || [];

  if (floorLevel !== 1) {
    return null;
  }

  if (title.length === 0) {
    const fallbackTitles = [];
    for (let i = 1; i <= 73; i++) {
      fallbackTitles.push({
        id: `${i}`,
        title: `Shop ${i}`
      });
    }
    for (let i = 1; i <= 5; i++) {
      fallbackTitles.push({
        id: `${i}`,
        title: `${i}`
      });
    }
    if (isSvg) {
      return (
        <g>
          <text x="20" y="30" dy="0.3em" fontSize="12" fill="black" fontWeight="bold">Shop List</text>
          {fallbackTitles.slice(0, 40).map((item, index) => (
            <g key={index}>
              <text x="20" y={50 + index * 12} dy="0.3em" fontSize="10" fill="#000000ff">{item.id}</text>
              <text x="40" y={50 + index * 12} dy="0.3em" fontSize="10" fill="black">{item.title}</text>
            </g>
          ))}
          {fallbackTitles.slice(40).map((item, index) => (
            <g key={`right-${index}`}>
              <text x="1000" y={50 + index * 12} dy="0.3em" fontSize="10" fill="#000000ff">{item.id}</text>
              <text   x="1020" y={50 + index * 12} dy="0.3em" fontSize="10" fill="black">{item.title}</text>
            </g>
          ))}
        </g>
      );
    }

    return (
      <div className={styles.titleList}>
        <h3 className={styles.title}>Shop List</h3>
        <div className={styles.list}>
          {fallbackTitles.map((item, index) => (
            <div key={index} className={styles.item}>
              <span className={styles.number}>{item.id}</span>
              <span className={styles.shopTitle}>{item.title}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (isSvg) {
    return (
      <g>
        <text x="20" y="30" dy="0.3em" fontSize="12" fill="black" fontWeight="bold">Shop List</text>
        {title.filter(({ title: shopTitle }) => shopTitle).slice(0, 40).map(({ title: shopTitle, id }, index) => (
          <g key={index}>
            <text x="20" y={50 + index * 12} dy="0.3em" fontSize="10" fill="#000000ff">{id.replace(/^1F-/, '')}</text>
            <text x="40" y={50 + index * 12} dy="0.3em" fontSize="10" fill="black">{shopTitle}</text>
          </g>
        ))}
        {title.filter(({ title: shopTitle }) => shopTitle).slice(40).map(({ title: shopTitle, id }, index) => (
          <g key={`right-${index}`}>
            <text x="1000" y={50 + index * 12} dy="0.3em" fontSize="10" fill="#000000ff">{id.replace(/^1F-/, '')}</text>
            <text   x="1020" y={50 + index * 12} dy="0.3em" fontSize="10" fill="black">{shopTitle}</text>
          </g>
        ))}
      </g>
    );
  }

  return (
    <div className={styles.titleList}>
      <h3 className={styles.title}>Shop List</h3>
      <div className={styles.list}>
        {title.filter(({ title: shopTitle }) => shopTitle).map(({ title: shopTitle, id }, index) => (
          <div key={index} className={styles.item}>
            <span className={styles.number}>{id.replace(/^1F-/, '')}</span>
            <span className={styles.shopTitle}>{shopTitle}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Floor1TitleList;